var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20331_8840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.433 8.1829C11.6771 7.93882 12.0728 7.93882 12.3169 8.1829C12.561 8.42697 12.561 8.8227 12.3169 9.06675L8.56688 12.8168C8.32283 13.0608 7.92709 13.0608 7.68302 12.8168C7.43894 12.5727 7.43894 12.177 7.68302 11.9329L11.433 8.1829ZM14.7916 2.1665C16.7476 2.1665 18.3333 3.75216 18.3333 5.70817V6.5415C18.3333 13.33 12.8301 18.8332 6.04163 18.8332H5.20829C3.25228 18.8332 1.66663 17.2475 1.66663 15.2915L1.66663 14.4582C1.66663 7.66967 7.16979 2.1665 13.9583 2.1665H14.7916ZM17.0833 5.70817C17.0833 4.44252 16.0573 3.4165 14.7916 3.4165H13.9583C13.6222 3.4165 13.2897 3.43151 12.9613 3.4609L17.0389 7.53843C17.0683 7.21005 17.0833 6.87753 17.0833 6.5415V5.70817ZM16.7944 9.06167L11.438 3.70543C7.33651 4.663 4.11383 7.90673 3.18674 12.0199L8.47996 17.313C12.5931 16.3859 15.8369 13.1633 16.7944 9.06167ZM2.95311 13.554C2.92894 13.8523 2.91663 14.1538 2.91663 14.4582V15.2915C2.91663 16.5572 3.94264 17.5832 5.20829 17.5832H6.04163C6.34606 17.5832 6.64762 17.5708 6.94583 17.5467L2.95311 13.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5417 13C11.5857 13 10 14.5857 10 16.5417C10 18.4977 11.5857 20.0833 13.5417 20.0833C15.4977 20.0833 17.0833 18.4977 17.0833 16.5417C17.0833 14.5857 15.4977 13 13.5417 13ZM13.2292 14.0417C13.3873 14.0417 13.5181 14.1593 13.5388 14.3118L13.5417 14.3542V16.5417H14.8958C15.0683 16.5417 15.2083 16.6817 15.2083 16.8542C15.2083 17.0123 15.0907 17.1431 14.9382 17.1638L14.8958 17.1667H13.2292C13.071 17.1667 12.9402 17.049 12.9195 16.8965L12.9167 16.8542V14.3542C12.9167 14.1817 13.0567 14.0417 13.2292 14.0417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7084,
    y: 14.0415,
    width: 0.833333,
    height: 3.33333,
    rx: 0.416667,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7084,
    y: 14.0415,
    width: 0.833333,
    height: 3.33333,
    rx: 0.416667,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.625,
    y: 16.5415,
    width: 0.833333,
    height: 2.91667,
    rx: 0.416667,
    transform: "rotate(90 15.625 16.5415)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.625,
    y: 16.5415,
    width: 0.833333,
    height: 2.91667,
    rx: 0.416667,
    transform: "rotate(90 15.625 16.5415)",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20331_8840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecaps);
export default __webpack_public_path__ + "static/media/recaps.855a4cbafb1642d801047539367c8bb9.svg";
export { ForwardRef as ReactComponent };